const ptTranslation = () => {
    return {
        global: {
            monday: 'Segunda-feira',
            tuesday: 'Terça-feira',
            wednesday: 'Quarta-feira',
            thursday: 'Quinta-feira',
            friday: 'Sexta-feira',
            saturday: 'Sábado',
            sunday: 'Domingo',
            lang: {
                fr: 'Francês (French)',
                gb: 'Inglês (English)',
                br: 'Brasil (Brazil)',
            },
        },
        home: {
            'main-title': "Badminton Villeneuve d'Ascq",
            'presentation-1': 'Jovens e Adultos, competidores e lazer, ',
            'presentation-2': ' ',
            'presentation-3': '',
            'presentation-4': ' O BVA promove a diversão para todos os jogadores de badminton.',
            'last-news': 'Últimas notícias',
        },
        header: {
            menu: {
                home: 'Início',
                planning: 'Planos e Preços',
                registration: 'Inscrever-se',
                competition: 'Torneios',
                contact: 'Fale conosco',
                'my-space-bva': 'Meu espaço BVA',
                login: 'Entre',
            },
            'my-tournament-account': 'Minha conta de torneios',
            'tournament-account-message':
                'A conta de torneios começa em 0€ e pode alcançar o máximo de 25€.Ela diz respeito somente aos competidores. É fácil para aumentar os valores na sua conta: basta participar dos treinamentos e nos avisar se estiver ausente.',
        },
        footer: {
            copyright: 'Copyright © 2022. Todos os direitos reservados - Site criado por',
            administration: 'Administrador',
        },
        sidebar: {
            admin: {
                dashboard: 'Painel',
                user: 'Usuário',
                news: 'Notícias',
                competition: 'Torneios',
                plannings: 'Planos',
                'bva-bot': 'BVA bot',
                notion: 'Notion',
                password: 'Senha',
            },
        },
        admin: {
            dashboard: 'Painel',
        },
        member: {
            dashboard: 'Painel',
            'welcome-1': 'Oi {{ user.firstname }} {{ user.lastname }},',
            'welcome-2': 'Bem-vindo à sua conta BVA',
            'welcome-3': 'Aqui é onde a sua conta de torneios é exibida (útil para a Licença de Competidor).',
            'welcome-4': 'No futuro, novas ferramentas serão adicionadas',
            'welcome-5':
                'Se você tem qualquer sugestão para melhoria do site nos contacte por email: president@bva-club.fr.',
            'last-news': 'Últimas notícias',
            'change-password-title': 'Mudar senha',
            'current-password-label': 'Senha atual',
            'new-password-label': 'Nova senha',
            'confirm-password-label': 'Confirme nova senha',
        },
        error: {
            'session-expired': 'Sua sessão expirou, você está sendo desconectado por motivos de segurança.',
        },
        page: {
            contact: {
                title: 'Fale conosco',
            },
            competition: {
                title: 'Torneios',
                'badnet-register': 'Se inscreva no BadNet',
                'tournament-account-register': 'Se inscreva com a sua conta de torneios',
                'need-login': 'Para usar a sua conta de torneios, você precisa se conectar',
                'no-data': 'Nenhum torneio ainda. Nós vamos adicioná-los em breve.',
            },
            price: {
                title: 'Preços para a temporada 2023/2024',
                'first-price-date-1':
                    'Preço completo para a temporada 2023/204 - inscrição de 1 de Agosto até 31 de Janeiro',
                'first-price-date-2':
                    'Preço reduzido para o primeiro semestre de 2024 - inscrição de 1 de Fevereiro até 30 de Junho',
                'young-1': 'Licença para Jovens: 120€',
                'competitor-1':
                    'Licença para Adulto Competidor: 160€ (Desconto para estudante: -20€) (Acesso aos jogos livres para competidores + interclubs inclusos)',
                'leisure-1':
                    'Licença para Adulto Lazer: 140€ (Desconto para estudante: -20€) (opção para jogar em interclubs: 5€)',
                'para-competitor-1': 'Licença Para-Badminton Competidor : 120€',
                'para-leisure-1': 'Licença Para-Badminton Lazer: €110',
                'young-2': 'Licença para Jovens : 95€',
                'competitor-2': 'Licença para Adulto Competidor : €110',
                'leisure-2': 'Licença para Adulto Lazer: €100',
                'para-competitor-2': 'Licença Para-Badminton Competidor: €90',
                'para-leisure-2': 'Licença Para-Badminton Lazer: €85',
                'title-try': 'Sessões Experimentais',
                'price-try-1': 'Antes de se registrar, você pode usufruir de 3 sessões experimentais.',
                'price-try-2': 'Nós podemos emprestar raquetes e petecas para as sessões experimentais.',
                'price-try-3': 'Após isso, você deve trazer sua própria raquete e petecas.',
            },
            login: {
                connexion: 'Login',
                member: 'membro',
                admin: 'administrador',
            },
        },
        bot: {
            init: 'Oi, como posso te ajudar? Faça uma pergunta curta e use palavras-chave. Por examplo, a palavra "preço" irá te redirecionar para a página com informações sobre valores. Para mensagens longas, nos contacte através do email : contact@bva-club.fr',
        },
        cookies:
            'Este site utiliza cookies que dura apenas 24h para medir o número de visitas com o objetivo de mostrar estes números para os nossos colaboradores e para melhorar o site para os usuários.',
    }
}

export default ptTranslation
